// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2jh-O","error":"Textarea_error__CZh3H","readonly":"Textarea_readonly__f7DfT","disabled":"Textarea_disabled__359vz"};